{
    "imageHost": "https://dks.scene7.com/is/image/"
}
